import React from "react";
import { useState } from "react";
import styles from "./Accordion.module.scss";

const Accordion = () => {
  const [isActive, setIsActive] = useState(true);

  const accordionData = {
    title: "Section 1",
    content: `Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quis sapiente
      laborum cupiditate possimus labore, hic temporibus velit dicta earum
      suscipit commodi eum enim atque at? Et perspiciatis dolore iure
      voluptatem.`,
  };

  //will return different div(content) based on accordion active state
  var Content = isActive ? (
    <div className={styles.accordioncontent}>{accordionData.content}</div>
  ) : (
    <div></div>
  );

  return (
    <React.Fragment>
      <h1>React Accordion Demo</h1>
      <div className={styles.accordion}>
        <div className={styles.accordionitem}>
          <div
            className={styles.accordiontitle}
            onClick={() => setIsActive(!isActive)}
          >
            <div>{accordionData.title}</div>
            <div>+</div>
          </div>
          {Content}
        </div>
      </div>
    </React.Fragment>
  );
};

export default Accordion;
